(function loadNativeIconsOnUse() {
  const template = document.getElementById('artbox-native-icon-styles');
  if (!template || template.dataset.installed) return;
  template.dataset.installed = 'true';
  const selector = '.la, .las, .lar, .lab';
  let observer;

  function load() {
    document.head.append(template.content.cloneNode(true));
    observer?.disconnect();
  }

  function hasIcon(node) {
    return node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector));
  }

  if (document.querySelector(selector)) {
    load();
    return;
  }

  observer = new MutationObserver((records) => {
    if (records.some((record) => record.type === 'attributes'
      ? record.target.matches(selector)
      : Array.from(record.addedNodes).some(hasIcon))) load();
  });
  observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
})();
